<template>
  <div
    class="flex flex-col min-h-full"
    :class="{'dark': isDarkTheme}"
    ref="myPresentations"
  >
    <div
      class="p-4 pt-6 md:px-6"
      :class="{'dark': isDarkTheme}"
    >
      <switch-tab-search
        v-if="!isEURegion && !isTestingNewSearch"
        v-show="isSearching"
      />
      <div
        v-if="selectedFolder"
        class="mb-4 flex flex-row min-h-full justify-between"
      >
        <aha-link @click="handleMyPresentationButtonClick" class="text-dark-theme">
          <span
            class="icon"
          >
            <aha-icon
              name="arrow-no-tail"
              height="16"
            />
          </span>
          <aha-icon />
          {{ $i18nPresenter.t("Back to My Presentations") }}
        </aha-link>
        <span
          v-if="!presentationsAndFoldersLoading"

          class="flex items-center justify-end cursor-pointer w-1/2"
        >
          <p
            class="inline-block mr-2 font-bold truncate dropdown-username
              text-link  max-w-ms-teams xl:max-w-108 "
          >
            {{ $store.state.currentUser.firstName }} {{ $store.state.currentUser.lastName }}
          </p>
          <aha-avatar
            :name="`${$store.state.currentUser.firstName} ${$store.state.currentUser.lastName}`"
            :image="$store.state.currentUser.avatar"
            :id="$store.state.currentUser.id"
            :width="28"
            :height="28"
            class="text-lg"
          />
          <aha-link
            class="ml-2 font-bold"
            variant="primary"
            type="primary"
            @click="$emit('logout')"
          >{{ $i18nPresenter.t("Logout") }}</aha-link>
        </span>
      </div>
      <div class="mb-4 flex flex-row min-h-full justify-between">
        <span v-if="!selectedFolder">
          <h2>{{ $i18nPresenter.t("My Presentations") }}</h2>
        </span>
        <span v-else class="flex flex-row items-center">
          <!-- Breacumb for normal user, hiding when user search something -->
          <span>
            <h2>{{ folderName }}</h2>
          </span>

        </span>

        <span
          v-if="!presentationsAndFoldersLoading && !selectedFolder"

          class="flex items-center justify-end cursor-pointer w-1/2"
        >
          <p
            class="inline-block mr-2 font-bold truncate dropdown-username
              text-link  max-w-ms-teams xl:max-w-108 "
          >
            {{ $store.state.currentUser.firstName }} {{ $store.state.currentUser.lastName }}
          </p>
          <aha-avatar
            :name="`${$store.state.currentUser.firstName} ${$store.state.currentUser.lastName}`"
            :image="$store.state.currentUser.avatar"
            :id="$store.state.currentUser.id"
            :width="28"
            :height="28"
            class="text-lg"
          />
          <aha-link
            class="ml-2 font-bold"
            variant="primary"
            type="primary"
            @click="$emit('logout')"
          >{{ $i18nPresenter.t("Logout") }}</aha-link>
        </span>
      </div>
      <div class="mb-4 border-b border-secondary-20"></div>
    </div>

    <div
      class="flex-grow"
      :class="{'flex items-center justify-center mr-4 ml-4 md:px-6':
        empty || presentationsAndFoldersLoading
      }"
    >
      <template
        v-if="presentationsAndFoldersLoading"
      >
        <InlineLoader
          :additionalClasses="['-mt-8', {
            '-mt-16': $route.name === 'SharedWithMe'}]"
        />
      </template>
      <div
        v-if="!presentationsAndFoldersLoading && (!presentations || presentations.length === 0 && folders.length === 0)"
        class="flex justify-center align-middle text-center flex-col h-52"
      >
        <div>
          <p
            target="presenterApp"

            title="AhaSlides Presenter App"
          >
            {{ $i18nPresenter.t("You don’t have any presentations yet.") }}
          </p>
          <aha-button
            class="inline mt-4"
            size="xl"
            @click="redirectToLink"
          >
            <aha-icon
              name="add"
              width="16"
              height="16"
              viewBox="0 0 24 24"
            />
            <span>{{ $i18nPresenter.t("New Presentation") }}</span>
          </aha-button>
        </div>
      </div>
      <template v-else>
        <div class="flex items-center justify-center h-full" v-if="empty">
          <not-found v-if="searchValue" />
          <on-boarding-box
            v-if="!searchValue && !$route.params.folderId"
            :shared="$route.name === 'SharedWithMe'"
          />
          <div v-if="!searchValue && $route.params.folderId">
            <empty :shared="$route.name === 'SharedWithMe'" />
            <tool-box
              class="flex justify-center w-full mt-4"
              :isHideSortBy="true"
            />
          </div>
        </div>

        <MSTeamsPresentationTable
          v-else
          class="pb-12"
          @selectPresentation="onSelectPresentation"
        />
      </template>
    </div>
    <LoadingScreen v-if="isCreatingNewPresentation || presentationsAndFoldersLoading" />
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex'

// configs
import configs from '@/config'

// event bus
import EventBus from '@/eventBus'

// utils
import utils from '@/util'
// constants
import constants from '@/constant'

// components
import NotFound from '@/components-v2/my-presentations/NotFound.vue'
import MSTeamsPresentationTable from '@/components-v2/ms-teams/MSTeamsPresentationTable.vue'

import ToolBox from '@/components-v2/my-presentations/ToolBox.vue'
import Empty from '@/components-v2/my-presentations/Empty.vue'
import LoadingScreen from './MSTeamsLoading.vue'
import SwitchTabSearch from '@/components-v2/template/SwitchTabSearch.vue'
import InlineLoader from '@/components-v2/common/loading/InlineLoader.vue'
import OnBoardingBox from '@/components-v2/my-presentations/OnBoardingBox.vue'
import msTeamsUtils from '@/utils/ms-teams'

const { eventCategories } = constants
const WHITE_LABEL = 'white-label'
export default {
  components: {
    NotFound,
    MSTeamsPresentationTable,
    ToolBox,
    Empty,
    LoadingScreen,
    SwitchTabSearch,
    InlineLoader,
    OnBoardingBox,
  },
  data() {
    return {
      domain: '',
      searchValue: '',
      presentationsAndFoldersLoading: true,
      showingGlobalNotification: true,
      notifications: [],
      presenterAppLink: null,
      isDarkTheme: false,
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
      currentAccount: (state) => state.currentAccount,
      folders: (state) => state.folders,
      isPresenterWhiteLabel: (state) => state.isPresenterWhiteLabel,
      numberOfPresentationPages: (state) => state.numbers.numberOfPresentationPages,
      numberOfLoadedPresentationPages: (state) => state.numbers.numberOfLoadedPresentationPages,
      morePresentationsLoading: (state) => state.loaders.morePresentationsLoading,
      selectedFolderId: (state) => state.selections.selectedFolderId,
      presentations: (state) => state.presentations,
      isServerConnectable: (state) => state.indicators.isServerConnectable,
      selectedSortCriteria: (state) => state.selections.selectedSortCriteria,
      isCreatingNewPresentation: (state) => state.isCreatingNewPresentation,
    }),
    ...mapGetters(['selectedFolder']),
    ...mapGetters({
      selectedPresentationToGetReport: 'presentationReport/selectedPresentation',
    }),
    empty() {
      if (this.selectedFolderId) {
        return this.presentations.length === 0
      }
      return this.presentations.length === 0 && this.folders.length === 0
    },
    folderName() {
      return utils.truncate(this.selectedFolder.folderName, 40)
    },
    breadcrumbCategory() {
      if (this.$route.name === 'Team') {
        return this.currentAccount.name
      }
      return 'Personal'
    },
    breadcrumbTitle() {
      if (this.$route.name === 'SharedWithMe') {
        return 'Shared with Me'
      }
      if (this.$route.name === 'Team') {
        return 'Team Presentations'
      }
      return this.$store.getters.selectedFolder ? this.$store.getters.selectedFolder.folderName : 'My Presentations'
    },
    isClickableBreadcrumb() {
      if (this.selectedFolder) {
        return true
      }
      return false
    },
    isEURegion() {
      return configs.region === constants.euRegion
    },
    isSearching() {
      return this.$route.query.q
    },
    hasPresentations() {
      return this.presentations && this.presentations.length > 0
    },
    isTestingNewSearch() {
      if (this.$store.state.currentUser.id % 4 === 1) return true
      return false
    },
  },

  watch: {
    'currentUser.whiteLabelLink': function handleWhiteLableLinkChange() {
      if (this.currentUser.plan === WHITE_LABEL) {
        this.domain = this.currentUser.whiteLabelLink
      }

      // Case: No Team but in Team route..
      if (
        this.currentUser
        && !this.currentUser.accountId
        && (this.$route.name === 'Team' || this.$route.name === 'TeamMember')
      ) {
        this.$router.push('/apps/presentations')
      }
    },
    selectedSortCriteria() {
      this.setNumberOfLoadedPresentationPagesAction(1)
      this._getPresentations()
    },
    selectedFolderId: function handleChangeRoute() {
      this.setNumberOfLoadedPresentationPagesAction(1)
      this._getPresentations()
    },
  },

  async created() {
    const isDarkTheme = await msTeamsUtils.isDarkThemeInMsTeams()
    this.isDarkTheme = isDarkTheme
  },
  async mounted() {
    // scroll to top to see global notifications. Avoid heading overlap
    window.scrollTo({ top: 0, behavior: 'smooth' })
    this.domain = configs.domain
    await this.getCurrentUserAction()

    this.searchValue = this.$route.query.q || ''
    this.presenterAppLink = `${configs.presenterDomain}/apps/presentations`

    this.setNumberOfLoadedPresentationPagesAction(1)
    window.addEventListener('scroll', this.handleMyPresentationsScroll)
    EventBus.$on('reload-presentations-and-folders', this._getPresentations)

    if (this.$route.params.folderId) {
      if (this.isFolderIdValid(this.$route.params.folderId)) {
        this.setSelectedFolderIdAction(parseInt(this.$route.params.folderId, 10))
      } else {
        this.$router.push({
          name: 'Presentations',
        })
      }
    }
    await this._getPresentations()
  },
  destroyed() {
    this.$store.state.openImportModal = false
    window.onscroll = null
    this.setSelectedFolderIdAction(null)
    EventBus.$off('reload-presentations-and-folders')
    window.removeEventListener('scroll', this.handleMyPresentationsScroll)
    this.unsubscribeReportAction()
    this.clearPresentationReportAction()
  },
  methods: {
    ...mapActions([
      'getPresentationsAction',
      'getSharedPresentationsAction',
      'setSelectedFolderIdAction',
      'getFoldersAction',
      'setFoldersAction',
      'setPresentationsAction',
      'setIsServerConnectableAction',
      'setNumberOfLoadedPresentationPagesAction',
      'setMorePresentationsLoadingAction',
      'setCurrentAccountAction',
      'getCurrentUserAction',
    ]),
    ...mapActions('presentationReport', ['clearPresentationReportAction', 'unsubscribeReportAction']),
    isFolderIdValid(folderId) {
      return !Number.isNaN(parseInt(folderId, 10))
    },
    async _getPresentations() {
      // if (this.$route.name === 'Presentations' || this.$route.name === 'FolderDetail') {
      await this.getPresentationsAndFolders()
    },
    redirectToLink() {
      utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Click New presentation')
      setTimeout(() => {
        window.open(this.presenterAppLink, '_blank')
      }, 50)
    },

    async getSharedPresentations() {
      if (!this.isServerConnectable) return

      const params = {
        page: this.numberOfLoadedPresentationPages,
        sortOrder: this.selectedSortCriteria.sortOrder,
        sortColumn: this.selectedSortCriteria.sortColumn,
      }

      if (this.searchValue.trim()) {
        params.textSearch = this.searchValue.trim()
      }

      // show loader
      if (this.numberOfLoadedPresentationPages === 1) {
        this.presentationsAndFoldersLoading = true
      } else {
        this.setMorePresentationsLoadingAction(true)
      }

      try {
        await this.getSharedPresentationsAction(params)
      } catch (error) {
        this.setIsServerConnectableAction(false)
        utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Shared Presentations > Load > Failed')
        throw error
      } finally {
        this.presentationsAndFoldersLoading = false
        this.setMorePresentationsLoadingAction(false)
      }

      utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Shared Presentations > Load > Succeeded')

      if (this.currentUser.plan === WHITE_LABEL) {
        this.domain = this.currentUser.whiteLabelLink
      }
    },

    async getPresentationsAndFolders() {
      if (!this.isServerConnectable) return
      const params = {
        page: this.numberOfLoadedPresentationPages,
        sortOrder: this.selectedSortCriteria.sortOrder,
        sortColumn: this.selectedSortCriteria.sortColumn,
        includeShared: true,
      }

      if (this.searchValue.trim()) {
        params.textSearch = this.searchValue.trim()
      } else {
        params.folderId = this.selectedFolderId || null
      }

      // show loader
      if (this.numberOfLoadedPresentationPages === 1) {
        this.presentationsAndFoldersLoading = true
      } else {
        this.setMorePresentationsLoadingAction(true)
      }

      try {
        if (this.numberOfLoadedPresentationPages === 1) {
          this.setPresentationsAction([])
          await this.getFoldersAction(params)
        }

        await this.getPresentationsAction(params)
      } catch (error) {
        this.setIsServerConnectableAction(false)
        utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Presentations > Load > Failed')
        throw error
      } finally {
        this.presentationsAndFoldersLoading = false
        this.setMorePresentationsLoadingAction(false)
      }

      // Disable for less noise to event
      // utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Presentations > Load > Succeeded')

      if (this.currentUser.plan === WHITE_LABEL) {
        this.domain = this.currentUser.whiteLabelLink
      }
    },
    onSelectPresentation(presentation) {
      this.$emit('selectPresentation', presentation)
    },
    async handleMyPresentationsScroll() {
      if (this.presentationsAndFoldersLoading) return

      if (this.morePresentationsLoading) return

      if (this.numberOfLoadedPresentationPages >= this.numberOfPresentationPages) return

      if (!this.$refs.myPresentations) return

      if (window.innerHeight + window.scrollY >= this.$refs.myPresentations.offsetHeight - 100) {
        this.setNumberOfLoadedPresentationPagesAction(this.numberOfLoadedPresentationPages + 1)
        await this._getPresentations()
      }
    },
    handleMyPresentationButtonClick() {
      if (this.selectedFolder) {
        this.setSelectedFolderIdAction(null)
      }
    },
  },
}
</script>
<style lang="scss" scroped>
.max-w-ms-teams{
  max-width : 60%;
}
.icon {
  transform: rotateY(180deg);
  padding-left: 5px;
}

</style>
